import ct from "class-types.macro";
import React from "react";

interface Props {
  label: string;
  value: string;
  dataTestId: string;
}
const DryerOutputSection = ({ label, value, dataTestId }: Props) => {
  const outputStyles: React.CSSProperties = {
    borderRadius: "4px",
    boxShadow: "inset 0 1px 4px rgb(0 0 0 / 4%), 0 1px 0 #fff",
    border: "1px solid rgba(0,0,0,.12)",
    background: "rgba(0,0,0,.04)",
  };
  return (
    <div style={outputStyles} className={ct("mt-6", "py-3", "px-4")}>
      <div
        style={{ borderBottom: "1px solid rgba(0,0,0,.08)" }}
        className={ct(
          "font-semibold",
          "text-base",
          "mb-1",
          "pb-1",
          "text-gray-800",
        )}
      >
        {label}
      </div>
      <div
        data-testid={dataTestId}
        className={ct("font-semibold", "text-2xl", "text-gray-900")}
      >
        {value}
      </div>
    </div>
  );
};
export default DryerOutputSection;
